"use client"

import { motion } from "framer-motion"
import { CtaButton } from "@/components/cta-button"
import { WaveBackground } from "@/components/wave-background"

export function CtaSection() {
  return (
    <section className="relative overflow-hidden py-32 md:py-48">
      <WaveBackground position="bottom" />
      <div className="relative mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 text-center">
        {/* Main heading */}
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-balance text-4xl font-bold tracking-tight text-foreground sm:text-5xl md:text-6xl"
        >
          Start moving money the modern way.
        </motion.h2>
        
        {/* Subheading with clear value proposition */}
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mx-auto mt-8 max-w-2xl text-pretty text-base leading-relaxed text-foreground/70"
        >
          Join leading businesses sending payments globally in seconds with unified infrastructure 
          across stablecoins, fiat, and local payment rails.
        </motion.p>
        
        {/* CTA buttons */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-12 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-5"
        >
          <CtaButton href="/contact?intent=demo" size="lg" arrow>
            Request a Demo
          </CtaButton>
          <CtaButton href="https://merchant.rombex.com/api-docs" size="lg" variant="secondary" external>
            Read Documentation
          </CtaButton>
        </motion.div>
      </div>
    </section>
  )
}
